import _ from 'lodash'
import { isCPF, isCNPJ } from 'brazilian-values'

export const isPasswordValid = (value) => {
  const specialChars = RegExp.escape("^$*.[]{}()?-\"!@#%&/\\,><':;|_~+=")
  const regex = new RegExp(`^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[${specialChars}])(?=.{8,})`)
  return regex.test(value)
}

export const cpfValid = (string) => {
  return _.isString(string) && isCPF(string)
}

export const cnpjValid = (string) => {
  return _.isString(string) && isCNPJ(string)
}
